import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  createFilledCustomFormsService,
  getFilledCustomFormsService,
  getInputDataWithMediaUrlService,
} from '../services/filledCustomFormsServices';
import uuidv4 from 'uuid/v4';
import { getSignedPdfUrlService } from 'scenes/Settings/FormEditor/services/getSignedPdfSignedUrlService';
import { putPdfFileToS3Service } from 'scenes/Settings/FormEditor/services/putPdfFileToS3Service';

export const getFilledCustomFormsThunk = createAsyncThunk(
  'customForms/getFilledCustomForms',
  async (payload, { getState, rejectWithValue }) => {
    try {
      const response = await getFilledCustomFormsService();
      return response;
    } catch (error) {
      return rejectWithValue('Failed to add NEW UNIT data');
    }
  }
);

export const createFilledCustomFormsThunk = createAsyncThunk(
  'customForms/createFilledCustomForms',
  async (payload, { getState, rejectWithValue }) => {
    try {
      const filledForm = {
        ...payload,
        id: uuidv4(),
        templateId: payload.id,
      };
      const response = await createFilledCustomFormsService(filledForm);
      return response;
    } catch (error) {
      return rejectWithValue('Failed to add NEW UNIT data');
    }
  }
);

export const updateFilledCustomFormsThunk = createAsyncThunk(
  'customForms/updateFilledCustomForms',
  async (payload, { getState, rejectWithValue }) => {
    try {
      const updatedFilledForm = {
        ...payload,
      };
      const response = await createFilledCustomFormsService(updatedFilledForm);
      return response;
    } catch (error) {
      return rejectWithValue('Failed to add NEW UNIT data');
    }
  }
);

export const saveInputImageToS3Thunk = createAsyncThunk(
  'customForms/saveInputImageToS3',
  async ({ inputData, fileId, fileBinary }, { getState, rejectWithValue }) => {
    console.log({ inputData, fileId, fileBinary });

    try {
      // GET SIGNED URL
      const { signedUrl, key } = await getSignedPdfUrlService(fileId);
      console.log('got signed url');

      // UPLOAD FILE
      await putPdfFileToS3Service(signedUrl, fileBinary);
      console.log('uploaded to s3');

      const { image, ...imagelessInputData } = inputData;
      // SAVE TO DB
      const response = await getInputDataWithMediaUrlService(
        imagelessInputData,
        key
      );

      console.log('saved to dynamodb');
      console.log(response);

      return response;
    } catch (error) {
      return rejectWithValue('Failed to add NEW');
    }
  }
);
